import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { INSURANCE_COMPANIES, CAUSE_NAMES } from './constants';

// Insurance Information Section
export const InsuranceInfoSection = ({ formData, onFormChange }) => {
  return (
    <div className="p-4 space-y-4">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label>Aseguradora *</Label>
          <Select 
            value={formData.insurance_company}
            onValueChange={(v) => onFormChange('insurance_company', v)}
          >
            <SelectTrigger data-testid="valuation-insurance-select">
              <SelectValue placeholder="Seleccionar aseguradora" />
            </SelectTrigger>
            <SelectContent>
              {INSURANCE_COMPANIES.map(c => (
                <SelectItem key={c.code} value={c.code}>{c.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>Código de Agencia</Label>
          <Input
            value={formData.agency_code}
            onChange={(e) => onFormChange('agency_code', e.target.value)}
            placeholder="Ej: AG-001"
            data-testid="agency-code-input"
          />
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label>Número de Póliza</Label>
          <Input
            value={formData.policy_number}
            onChange={(e) => onFormChange('policy_number', e.target.value)}
            placeholder="Ej: POL-123456"
            data-testid="valuation-policy-input"
          />
        </div>
        <div>
          <Label>Número de Siniestro/Reclamo</Label>
          <Input
            value={formData.claim_number}
            onChange={(e) => onFormChange('claim_number', e.target.value)}
            placeholder="Ej: SIN-2026-001234"
            data-testid="valuation-claim-input"
          />
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label>Deducible de la Póliza (₡)</Label>
          <Input
            type="number"
            min="0"
            value={formData.deductible}
            onChange={(e) => onFormChange('deductible', e.target.value)}
            placeholder="Ej: 150000"
            data-testid="valuation-deductible-input"
          />
        </div>
      </div>
      <p className="text-xs text-slate-500">
        La aseguradora, número de póliza y deducible se guardarán automáticamente en el perfil del vehículo del cliente.
      </p>
    </div>
  );
};

// Incident Information Section
export const IncidentInfoSection = ({ formData, onFormChange }) => {
  return (
    <div className="p-4 space-y-4">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label>Fecha del Incidente</Label>
          <Input
            type="date"
            value={formData.incident_date}
            onChange={(e) => onFormChange('incident_date', e.target.value)}
            data-testid="incident-date-input"
          />
        </div>
        <div>
          <Label>Causa del Daño *</Label>
          <Select 
            value={formData.incident_cause}
            onValueChange={(v) => onFormChange('incident_cause', v)}
          >
            <SelectTrigger data-testid="incident-cause-select">
              <SelectValue placeholder="Seleccionar causa" />
            </SelectTrigger>
            <SelectContent>
              {Object.entries(CAUSE_NAMES).map(([key, name]) => (
                <SelectItem key={key} value={key}>{name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div>
        <Label>Ubicación del Incidente</Label>
        <Input
          value={formData.incident_location}
          onChange={(e) => onFormChange('incident_location', e.target.value)}
          placeholder="Ej: Ruta 32, km 45, Limón"
          data-testid="incident-location-input"
        />
      </div>
      <div>
        <Label>Descripción del Incidente *</Label>
        <Textarea
          value={formData.incident_description}
          onChange={(e) => onFormChange('incident_description', e.target.value)}
          placeholder="Describa detalladamente cómo ocurrió el incidente..."
          rows={3}
          data-testid="incident-description-textarea"
        />
      </div>
    </div>
  );
};

// Notes Section
export const NotesSection = ({ formData, onFormChange }) => {
  return (
    <div className="p-4 space-y-4">
      <div>
        <Label>Notas Adicionales</Label>
        <Textarea
          value={formData.notes}
          onChange={(e) => onFormChange('notes', e.target.value)}
          placeholder="Notas internas, observaciones especiales..."
          rows={2}
          data-testid="valuation-notes-textarea"
        />
      </div>
      <div>
        <Label>Recomendaciones</Label>
        <Textarea
          value={formData.recommendations}
          onChange={(e) => onFormChange('recommendations', e.target.value)}
          placeholder="Recomendaciones para el cliente o la aseguradora..."
          rows={2}
          data-testid="valuation-recommendations-textarea"
        />
      </div>
    </div>
  );
};
